import React from "react";
import "./Certificates.css";
// import bgimage from "../Assessts/certificates/background6.png";
// import bgimage from "../Assessts/certificate1.png";
import bgimage from "../Assessts/certificate2.png";

import cert1 from "../Assessts/certificates/CE.png";
import cert2 from "../Assessts/certificates/DPIIT.png";
import cert3 from "../Assessts/certificates/DRDO.png";
import cert4 from "../Assessts/certificates/EPFO.png";
import cert5 from "../Assessts/certificates/ESIC.png";
import cert6 from "../Assessts/certificates/india.png";
import cert7 from "../Assessts/certificates/iso.png";
import cert8 from "../Assessts/certificates/isro.png";
import cert9 from "../Assessts/certificates/mcf.png";
import cert10 from "../Assessts/certificates/MSME.png";
import cert11 from "../Assessts/certificates/rail.png";
import cert12 from "../Assessts/certificates/trade.png";

export default function Certificates() {
  const partners = [
    cert1,
    cert2,
    cert3,
    cert4,
    cert5,
    cert6,
    cert7,
    cert8,
    cert9,
    cert10,
    cert11,
    cert12,
  ];

  return (
    <div className="certificates-container">
      {/* Background Section */}
      <div style={{ position: "relative", marginBottom: 50 }}>
        <img
          src={bgimage}
          alt="About Us"
          style={{
            width: "100vw",
            height: "70vh",
            objectFit: "cover",
            filter: "brightness(100%)",
            display: "block",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>
            Our Certifications
          </h1>
          <p>
            <span style={{ color: "#fff" }}>Home</span>{" "}
            {/* <span style={{ color: "#155382ff" }}>/certifications</span> */}
            <span style={{ color: "white" }}>/certifications</span>
          </p>
        </div>
      </div>



      {/* Descriptive Content Section */}
 <div
  style={{
    maxWidth: "1000px",
    margin: "60px auto",
    fontSize: "17px",
    lineHeight: "1.8",
    color: "#333",
    padding: "0 20px",
    textAlign: "left", // ✅ ensures text starts from the left
  }}
>
  <h2
    style={{
      color: "#155382ff",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "center", // keep heading centered
    }}
  >
    Certifications & Recognitions
  </h2>

  <p>
    Committed to excellence and quality,{" "}
    <b>Technocrat Aerospace and Defence Private Limited</b> adheres to globally
    recognized standards and holds multiple key certifications. As an{" "}
    <b>ISO 9001:2015 certified</b> and <b>CE-marked</b> company, we ensure our
    products meet stringent requirements for <b>safety</b>, <b>reliability</b>,
    and <b>performance</b>.
  </p>

  <p style={{ marginTop: "15px" }}>
    Our capabilities and compliance are further demonstrated by the following
    recognitions:
  </p>

  <div style={{ marginTop: "20px" }}>
    <h3 style={{ color: "#155382", marginBottom: "5px" }}>
      Government & Industry Recognitions
    </h3>
    <p style={{ marginTop: "0px" }}>
      <b>Startup India (DPIIT):</b> Recognized as an innovative startup by the
      Department for Promotion of Industry and Internal Trade.
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>Make in India:</b> Aligned with the national initiative to foster
      manufacturing and innovation within the country.
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>MSME:</b> Registered as a Micro, Small, and Medium Enterprise.
    </p>

    <h3
      style={{
        color: "#155382",
        marginTop: "20px",
        marginBottom: "5px",
      }}
    >
      Statutory & Compliance Registrations
    </h3>
    <p style={{ marginTop: "0px" }}>
      <b>ESIC:</b> Employees' State Insurance Corporation
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>EPF:</b> Employees' Provident Fund Organisation
    </p>

    <h3
      style={{
        color: "#155382ff",
        marginTop: "20px",
        marginBottom: "5px",
      }}
    >
      Vendor Approvals & Partnerships
    </h3>
    <p style={{ marginTop: "0px" }}>
      <b>DRDO:</b> Defence Research and Development Organisation
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>ISRO:</b> Indian Space Research Organisation
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>RDSO:</b> Research Designs and Standards Organisation
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>HAL:</b> Hindustan Aeronautics Limited
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>BHEL:</b> Bharat Heavy Electricals Limited
    </p>
    <p style={{ marginTop: "0px" }}>
      <b>MCF:</b> Modern Coach Factory, Rae Bareli
    </p>
  </div>

  <p style={{ marginTop: "25px" }}>
    These certifications and approvals underscore our trusted position as a{" "}
    <b>qualified partner</b> for critical applications in the{" "}
    <b>Defence</b>, <b>Aerospace</b>, and <b>Railways</b> sectors.
  </p>
</div>





      
      {/* Section Title */}
      <h1
        style={{
          color: "#155382ff",
          marginBottom: "20px",
        }}
      >
        <span>Our Certifications</span>
      </h1>


            {/* Scrolling Certificates Section */}
      <div className="certificates-slider">
        <div className="certificates-track">
          {partners.concat(partners).map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Certificate ${index}`}
              className="certificate-logo"
            />
          ))}
        </div>
      </div>

    </div>
  );
}
